const PREFIX = "Shared/Misc/";

export const INIT_APP = `${PREFIX}INIT_APP`;
